// Utility functions for consistent strength tag colors

const STRENGTH_COLOR_PALETTE = [
    { bg: '#4A90E2', text: 'white' },
    { bg: '#50E3C2', text: 'white' },
    { bg: '#F5A623', text: 'white' },
    { bg: '#9B59B6', text: 'white' },
    { bg: '#E74C3C', text: 'white' },
    { bg: '#2ECC71', text: 'white' },
    { bg: '#F39C12', text: 'white' },
    { bg: '#3498DB', text: 'white' },
    { bg: '#E67E22', text: 'white' },
    { bg: '#1ABC9C', text: 'white' },
    { bg: '#34495E', text: 'white' },
    { bg: '#8E44AD', text: 'white' },
    { bg: '#16A085', text: 'white' },
    { bg: '#27AE60', text: 'white' },
    { bg: '#2980B9', text: 'white' },
    { bg: '#C0392B', text: 'white' },
    { bg: '#D35400', text: 'white' },
    { bg: '#7F8C8D', text: 'white' },
    { bg: '#0cc2ffff', text: 'white' },
    { bg: '#95A5A6', text: 'white' }
];


const stringToHash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
    }
    return Math.abs(hash);
};

export const getStrengthColor = (strength) => {
    if (!strength) return STRENGTH_COLOR_PALETTE[0].bg;
    
    const normalizedStrength = strength.toLowerCase().trim();
    
    const hash = stringToHash(normalizedStrength);
    const colorIndex = hash % STRENGTH_COLOR_PALETTE.length;
    
    return STRENGTH_COLOR_PALETTE[colorIndex].bg;
};

export const getStrengthTextColor = (strength) => {
    if (!strength) return STRENGTH_COLOR_PALETTE[0].text;
    
    const normalizedStrength = strength.toLowerCase().trim();
    
    const hash = stringToHash(normalizedStrength);
    const colorIndex = hash % STRENGTH_COLOR_PALETTE.length;
    
    return STRENGTH_COLOR_PALETTE[colorIndex].text;
};

export const getStrengthColors = (strength) => {
    if (!strength) return STRENGTH_COLOR_PALETTE[0];
    
    const normalizedStrength = strength.toLowerCase().trim();
    
    const hash = stringToHash(normalizedStrength);
    const colorIndex = hash % STRENGTH_COLOR_PALETTE.length;
    
    return STRENGTH_COLOR_PALETTE[colorIndex];
};
